export default __webpack_public_path__ + "static/Semrush-36d06eaa4f0e2685e6a82e5bd2aa995b.png";